function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Filters.css';
import React, { useEffect, useState } from 'react';
import { canUseDOM, get, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { qsToObject } from '../../utils/querystring';
import { useHistory, useLocation } from 'react-router-dom';
import FiltersMobileSwitchPanel from './components/FiltersMobileSwitchPanel/FiltersMobileSwitchPanel';
import DropDownMultiselect from './components/DropDownMultiselect/DropDownMultiselect';
import Sorting from './components/Sorting';
import FiltersSelected from './components/FiltersSelected/FiltersSelected';
import { convertToAnalyticObject } from '../../utils/analytics';
import { commonStyles as headerStyle } from '../57_HeaderListingPage/HeaderListingPage';
import RestaurantsListingSearch from './components/RestaurantsListingSearch/RestaurantsListingSearch';
import DropDown from './components/DropDown/DropDown';
import { splitter } from '../Listing';
const stateTofacetsObj = filterState => {
  return Object.keys(filterState).reduce((acc, item) => {
    const currentFacetName = filterState[item].facetName;
    const currentValues = filterState[item].value;
    return _objectSpread(_objectSpread({}, acc), {}, {
      [currentFacetName]: acc[currentFacetName] ? [...acc[currentFacetName], ...currentValues] : currentValues
    });
  }, {});
};
const filteredByFacetsToDisplay = (filterState, facets) => {
  const filters = _objectSpread({}, filterState);
  return Object.values(filters).map(item => {
    const facetType = item.facetName;
    const availableValues = facets[facetType];
    if (availableValues) {
      return _objectSpread(_objectSpread({}, item), {}, {
        value: item.value.filter(val => val in availableValues)
      });
    }
    return _objectSpread({}, item);
  });
};
const combineValuesBySameFacetNames = filters => {
  const combineValues = Object.values(filters).reduce((acc, item) => {
    const facet = item.facetName;
    if (acc[facet]) {
      acc[facet] = _objectSpread(_objectSpread({}, acc[facet]), {}, {
        value: [...acc[facet].value, ...item.value]
      });
    } else {
      acc[facet] = _objectSpread(_objectSpread({}, item), {}, {
        value: [...item.value]
      });
    }
    return acc;
  }, {});
  return Object.values(combineValues).reduce((acc, item) => {
    acc[item.title] = item;
    return acc;
  }, {});
};
const updateQueryString = (filterState, facets, history) => {
  if (canUseDOM) {
    const url = new URL(window.location.href);
    const getFiltersToDisplay = () => {
      const filteredByFacets = filteredByFacetsToDisplay(filterState, facets);
      return combineValuesBySameFacetNames(filteredByFacets);
    };
    const filters = getFiltersToDisplay();
    const filterStateKeysArray = Object.keys(filters);
    filterStateKeysArray.forEach((filterKey, index) => {
      const currentFacetName = filters[filterKey].facetName;
      const currentValues = filters[filterKey].value;
      url.searchParams.delete(currentFacetName);
      const newQueryArr = [];
      if (currentValues.length) {
        currentValues.forEach(key => newQueryArr.push(key));
      } else {
        Object.keys(currentValues).forEach(key => {
          if (currentValues[key]) {
            newQueryArr.push(key);
          }
        });
      }
      if (newQueryArr.length) {
        url.searchParams.set(currentFacetName, newQueryArr.join(splitter));
      }
    });
    if ([...url.searchParams.keys()].length) {
      history.push(`${url.search}${url.hash}`);
    } else {
      history.push(window.location.pathname);
    }
  }
};
const Filter = _ref => {
  let {
    fields,
    params,
    setpage,
    setHits,
    facets,
    applySetFilters,
    rtl,
    searchTextValue,
    setSearchTextValue,
    sortingValue,
    setSortingValue,
    nbHits,
    withMapModalView = false,
    filterState,
    setFilterState
  } = _ref;
  const location = useLocation();
  const history = useHistory();
  const [filtersCount, setFiltersCount] = useState(0);
  const queryParams = canUseDOM ? qsToObject(location.search) : {};
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const dictionary = get(fields, 'data.dictionary');
  const sortField = get(fields, 'data.listingConfiguration.sorting.sortPrefixes') || [];
  const filterData = get(fields, 'data.listingConfiguration.filters') || {};
  const [filtersMobileItemsVisible, setFiltersMobileItemsVisible] = useState(false);
  const [filterFiledOpened, setFilterFiledOpened] = useState('');

  /* Dictionary terms */
  const clearAllText = getDictionaryItem(dictionary, 'ClearAll') || '';
  const clearText = getDictionaryItem(dictionary, 'Clear') || '';
  const filtersTitleText = getDictionaryItem(dictionary, 'FiltersLabel') || '';
  const autocompletePlaceholderText = getDictionaryItem(dictionary, 'SearchFilterPlaceholder') || '';
  const filtersMobileLabelText = getDictionaryItem(dictionary, 'Filters') || '';
  const filtersMobileLabelPanelText = getDictionaryItem(dictionary, 'filterPanelLabel') || '';
  const showResultsText = getDictionaryItem(dictionary, 'ShowResults') || '';
  const sortFieldDeskLabelText = `${getDictionaryItem(dictionary, 'SortLabel')}${getDictionaryItem(dictionary, 'DefaultFilter')}` || '';
  const sortFieldMobileLabelText = getDictionaryItem(dictionary, 'Sorting') || '';
  const pleaseSelectText = getDictionaryItem(dictionary, 'PleaseSelect') || '';
  let filteredResultsText = getDictionaryItem(dictionary, 'FilteredResultsText') || '';
  useEffect(() => {
    let count = 0;
    for (let key in filterState) {
      const isFullFalseObj = () => {
        let isFullFalseObj = true;
        if (filterState[key].value !== null) {
          Object.values(filterState[key].value).forEach(el => {
            if (el) {
              isFullFalseObj = false;
            }
          });
        }
        return isFullFalseObj;
      };
      if (typeof filterState[key].value === 'string' ? filterState[key].value !== null : !isFullFalseObj()) {
        count = count + 1;
      }
    }
    setFiltersCount(count);
  }, [filterState]);
  useEffect(() => {
    updateQueryString(filterState, facets, history);
  }, [facets]);
  const getFilteredResultText = (filteredResultsText, nbHits, searchTextValue) => {
    const values = [nbHits, searchTextValue];
    values.forEach((value, index) => {
      if (index === values.length - 1) {
        filteredResultsText = filteredResultsText.replace(new RegExp(`\\{${index}\\}`, 'g'), `<strong>${value}</strong>`);
        return;
      }
      filteredResultsText = filteredResultsText.replace(new RegExp(`\\{${index}\\}`, 'g'), value);
    });
    return filteredResultsText;
  };
  if (Object.keys(queryParams).length !== 0) {
    for (let key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  const filterSelectedAnalyticsClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['FilterClickAnalytics'], params), text);
  };
  const cuisineAnalyticsButtonClick = (fieldName, newValue) => {
    const currentFiled = `${fieldName}: ${get(newValue, 'value', []).join(', ')}`;
    const otherFields = Object.keys(filterState).filter(el => el !== fieldName).reduce((acc, currentFilterKey) => {
      if (filterState[currentFilterKey].value.length) {
        acc += `${currentFilterKey}: ${filterState[currentFilterKey].value.join(', ')}`;
      }
      return acc;
    }, '');
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['applyFilterAnalytics'], params), `${showResultsText}:${currentFiled}${otherFields ? ': ' : ''}${otherFields}`);
  };
  const removeFilterAnalyticsClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['removeFilterAnalytics'], params), text);
  };
  const setListingFilter = () => {
    setpage(0);
    setHits([]);
    applySetFilters(true);
  };
  const resetAndSubmitFilters = () => {
    const newState = _objectSpread({}, filterState);
    Object.keys(newState).forEach(filterName => {
      newState[filterName].value = [];
    });
    const finalQSObject = stateTofacetsObj(newState);
    const url = new URL(window.location.href);
    Object.keys(finalQSObject).forEach(facet => {
      url.searchParams.delete(facet);
    });
    history.replace(`${history.location.pathname}${url.search}${url.hash}`);
    setFilterState(newState);
    setListingFilter();
    removeFilterAnalyticsClick(filtersMobileLabelText);
  };
  const toggleMapButton = function () {
    let hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (canUseDOM) {
      const button = document.querySelector('#interactive-map-toggle');
      if (button) {
        button.style.zIndex = hide ? '1' : '2';
      }
    }
  };
  const togglePanelHandler = close => {
    setFiltersMobileItemsVisible(close === false ? close : !filtersMobileItemsVisible);
    if (close !== false && document.body.style.overflowY === '') {
      document.body.style.overflowY = 'hidden';
      toggleMapButton(true);
    } else {
      document.body.style.overflowY = '';
      toggleMapButton(false);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `row ${withMapModalView ? 'rest-map-view' : ''} `
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, !withMapModalView ? /*#__PURE__*/React.createElement("div", {
    className: "filters__search"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-10 col-xl-11"
  }, /*#__PURE__*/React.createElement(RestaurantsListingSearch, {
    rtl: rtl,
    searchValue: searchTextValue,
    setSearchValue: setSearchTextValue,
    placeholder: autocompletePlaceholderText,
    setListingFilter: setListingFilter,
    eventsAnalytics: eventsAnalytics,
    params: params
  })))) : null, filtersTitleText && /*#__PURE__*/React.createElement("h5", {
    className: "filters__header"
  }, filtersTitleText), /*#__PURE__*/React.createElement("div", {
    className: `filters__grid ${withMapModalView ? 'imfilters-padding' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${withMapModalView ? 'col-xl-12' : 'col-6 col-lg-9 col-xl-10'}`
  }, /*#__PURE__*/React.createElement(FiltersMobileSwitchPanel, {
    filterState: filterState,
    emptyFilterState: "",
    labelText: filtersMobileLabelText,
    filterPanelLabel: filtersMobileLabelPanelText,
    clearAll: clearAllText,
    ctaText: showResultsText,
    togglePanel: togglePanelHandler,
    panelVisible: filtersMobileItemsVisible,
    clearFilter: () => {
      togglePanelHandler();
      resetAndSubmitFilters();
    },
    triggerFilterFieldOpen: setFilterFiledOpened,
    pleaseSelectText: pleaseSelectText,
    withMapModalView: withMapModalView,
    filtersCount: filtersCount
  }), /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout-wrapper"
  }, !!(filterData.values && filterData.values.length) && /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout"
  }, filterData.values.map(singleFilter => {
    const filterTemplate = get(singleFilter, 'fieldTypeItem.item.fieldType.value');
    const facetName = get(singleFilter, 'fieldNameItem.item.fieldName.value');
    const tagsToDisplay = get(singleFilter, 'tagsToDisplay.values');
    if (filterTemplate === 'Dropdown') {
      const fieldName = get(singleFilter, 'name');
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: `${withMapModalView ? `map-view-${fieldName}` : `${fieldName}`}`
      }, /*#__PURE__*/React.createElement(DropDown, {
        filter: singleFilter,
        algoliaResponcedFacetValues: facets[facetName],
        closeMobileOpener: () => togglePanelHandler(false),
        setValue: newValue => {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, {
            [fieldName]: _objectSpread(_objectSpread({}, filterState[fieldName]), newValue)
          }));
        },
        value: filterState[fieldName] === undefined ? [] : filterState[fieldName].value,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened,
        analyticCheckboxCallback: filterSelectedAnalyticsClick,
        analyticButtonCallback: cuisineAnalyticsButtonClick,
        withMapModalView: withMapModalView
      }));
    }
    if (filterTemplate === 'Dropdown Multi Select' && !!tagsToDisplay.length) {
      const fieldName = get(singleFilter, 'name');
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: `${withMapModalView ? `map-view-${fieldName}` : `${fieldName}`}`
      }, /*#__PURE__*/React.createElement(DropDownMultiselect, {
        filter: singleFilter,
        algoliaResponcedFacetValues: facets[facetName],
        closeMobileOpener: () => togglePanelHandler(false),
        setValue: newValue => {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, {
            [fieldName]: _objectSpread(_objectSpread({}, filterState[fieldName]), newValue)
          }));
        },
        value: filterState[fieldName] === undefined ? [] : filterState[fieldName].value,
        filterState: filterState,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened,
        analyticCheckboxCallback: filterSelectedAnalyticsClick,
        analyticButtonCallback: cuisineAnalyticsButtonClick,
        resetAndSubmitFilters: resetAndSubmitFilters,
        withMapModalView: withMapModalView
      }));
    }
    return null;
  })))), !withMapModalView ? /*#__PURE__*/React.createElement("div", {
    className: "col-6 col-lg-3 col-xl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__sort"
  }, /*#__PURE__*/React.createElement(Sorting, {
    values: sortField,
    deskLabelText: sortFieldDeskLabelText,
    mobileLabelText: sortFieldMobileLabelText,
    defaultSortValue: '',
    value: sortingValue,
    setSort: newValue => {
      setSortingValue(newValue);
    },
    clearText: clearText,
    setListingFilter: setListingFilter,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))) : null)), !withMapModalView ? /*#__PURE__*/React.createElement(FiltersSelected, {
    filterState: filterState,
    setFilter: newValue => {
      setFilterState(_objectSpread(_objectSpread({}, filterState), newValue));
    },
    resetFilters: newValue => {
      setFilterState(newValue);
    },
    clearText: clearAllText,
    setListingFilter: setListingFilter,
    facets: facets,
    resetAndSubmitFilters: resetAndSubmitFilters,
    analyticsClick: removeFilterAnalyticsClick
  }) : null, searchTextValue && nbHits ? /*#__PURE__*/React.createElement("p", {
    className: "searchResultCounter",
    dangerouslySetInnerHTML: {
      __html: getFilteredResultText(filteredResultsText, nbHits, searchTextValue)
    }
  }) : null))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${headerStyle}   ${commonStyleModalFilterValue} ${commonStyles} ${rtl ? rtlStyles : ltrStyles}   ${rtl ? rtlStylesModalFiltersValue : ''}`
  }, children);
};
export default Filter;
const commonStyles = "cc56l1y";
const ltrStyles = "l49mu5h";
const rtlStyles = "rmdqj96";
const commonStyleModalFilterValue = "c1wwitsu";
const rtlStylesModalFiltersValue = "r18ovil";